import React, { useRef, useMemo } from "react";
import {Button, Form } from 'antd';
import { mapItem, mapItemsBulk } from "../../stateManagement/actions/data";
import { useDispatch } from "react-redux";
import { ADMIN_ACCESS, PARTITION_MAIN, UNIQUE_PLACEMENT_TYPES } from "../../utils/constants";
import SelectableFormField from "./selectableFormField";

const ManualMappingForm = ({websitesList, publishersList, currentValues, closeModal, partition = PARTITION_MAIN}) => {

    const formRef = useRef(null);
    const dispatch = useDispatch();

    // Handle single item mapping
    const handleSingleMapping = () => {
        dispatch(mapItem(currentValues._id, {...formRef.current.getFieldsValue()}, partition))
        handleReset();
        closeModal();
    };

    // Handle bulk mapping
    const handleBulkMapping = () => {
        dispatch(mapItemsBulk(currentValues._id, {...formRef.current.getFieldsValue()}, partition))
        handleReset();
        closeModal();
    };

    // Handle form reset
    const handleReset = () => formRef.current?.resetFields();

    // Memoize options to prevent unnecessary recalculations
    const publisherOptions = useMemo(() => [...new Set(publishersList.map(i => i.returnedValue).filter(i => i !== ADMIN_ACCESS))], [publishersList]);
    const websiteOptions = useMemo(() => [...new Set(websitesList.map(i => i.domain))], [websitesList]);

    return(
        <Form ref={formRef}>
            <SelectableFormField 
                name="publisher"
                options={publisherOptions}
                label={`${currentValues.publisher} =>`}            
            />
            <SelectableFormField 
                name="website"
                options={websiteOptions}
                label={`${currentValues.website} =>`}  
            />
            <SelectableFormField 
                name="placementFormat"
                options={UNIQUE_PLACEMENT_TYPES}
                label={`${currentValues.placementFormat} =>`}  
            />
            <Form.Item>
                <Button.Group>
                    <Button 
                        type="default" 
                        htmlType="submit"
                        onClick={handleBulkMapping}
                    >
                        Map all
                    </Button>
                    <Button 
                        type="default" 
                        htmlType="submit"
                        onClick={handleSingleMapping}
                    >
                        Single mapping
                    </Button>
                    <Button 
                        type="danger" 
                        htmlType="button" 
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                </Button.Group>
            </Form.Item>
        </Form>
    )
}

export default ManualMappingForm;